<template>
  <div class="modal-mask">
    <div
      class="modal-container"
      :class="screenSize.resolution_allowed && !showZoomSteps ? 'container-responsive' : ''"
    >
      <!-- <img
        src="../assets/Cross_Symbol_big.svg"
        class="close-icon"
        @click="$emit('close')"
      /> -->
      <header class="system-compatible-header">
        <div class="system-compatible-header-image">
          <img
            src="../assets/System_incp.svg"
            alt="system-incompatible"
            class="img-responsive"
          />
        </div>
        <div class="system-compatible-header-description">
          <h1 class="system-compatible-header-description-context">
            <span></span> System compatibility check
          </h1>

          <ul class="system-compatible-header-description-list">
            <!-- browser zoom level compatibility -->
            <li v-if="showZoomSteps"
              :class="showZoomSteps ? 'compatibility-failed-background' : ''"
              class="system-compatible-header-description-list-element">
              <span>
                <img
                  v-if="!showZoomSteps"
                  src="../assets/pass_green.svg"
                  alt=""
                  class="pass-green"
                />
                <img
                  v-if="showZoomSteps"
                  src="../assets/Cross_Symbol.svg"
                  alt=""
                  class="pass-green"
                />
                <span v-if="!showZoomSteps" class="message">
                  Browser zoom compatible for the test
                </span>
                <span v-if="showZoomSteps" class="message">
                  Please set your Browser Zoom level to 100%
                </span>
              </span>
            </li>

            <!-- physical resolution compatibility -->
            <li v-else-if="showPhysicalResolutionSteps"
              :class="
                showPhysicalResolutionSteps
                  ? 'compatibility-failed-background'
                  : ''
              "
              class="system-compatible-header-description-list-element"
            >
              <span>
                <img
                  v-if="!showPhysicalResolutionSteps"
                  src="../assets/pass_green.svg"
                  alt=""
                  class="pass-green"
                />
                <img
                  v-if="showPhysicalResolutionSteps"
                  src="../assets/Cross_Symbol.svg"
                  alt=""
                  class="pass-green"
                />
                <span v-if="showPhysicalResolutionSteps" class="message">
                  Your system is not compatible to take the test. Please check your system settings.
                </span>
              </span>
            </li>

            <!-- screen resolution compatibility -->
            <li v-else-if="!screenSize.resolution_allowed"
              :class="
                !screenSize.resolution_allowed
                  ? 'compatibility-failed-background'
                  : ''
              "
              class="system-compatible-header-description-list-element"
            >
              <span>
                <img
                  v-if="screenSize.resolution_allowed"
                  src="../assets/pass_green.svg"
                  alt=""
                  class="pass-green"
                />
                <img
                  v-if="!screenSize.resolution_allowed"
                  src="../assets/Cross_Symbol.svg"
                  alt=""
                  class="pass-green"
                />
                <span v-if="screenSize.resolution_allowed" class="message">
                  System Resolution is compatible for the test
                </span>
                <span v-if="!screenSize.resolution_allowed" class="message">
                  The screen resolution is less than required (1024*768)
                </span>
              </span>
            </li>

            <!-- os compatibility -->
            <li
              class="system-compatible-header-description-list-element"
              :class="!os.os_allowed ? 'compatibility-failed-background' : ''"
            >
              <span>
                <img
                  v-if="os.os_allowed"
                  src="../assets/pass_green.svg"
                  class="pass-green"
                  alt=""
                />
                <img
                  v-else
                  src="../assets/Cross_Symbol.svg"
                  class="pass-green"
                  alt=""
                />
                <span class="message">
                  <b>Operating System</b> : {{ os.os_name }}
                </span>
                <br />
              </span>
            </li>

            <li
              class="system-compatible-header-description-list-element"
              :class="
                !showCookieBlockedSteps ? 'compatibility-failed-background' : ''
              "
            >
              <span>
                <img
                  v-if="showCookieBlockedSteps"
                  src="../assets/pass_green.svg"
                  class="pass-green"
                  alt=""
                />
                <img
                  v-else
                  src="../assets/Cross_Symbol.svg"
                  class="pass-green"
                  alt=""
                />
                <span class="message">
                  <b>Cookies Enabled</b>
                </span>
                <br />
              </span>
            </li>

            <!-- browser compatibility -->
            <li
              class="system-compatible-header-description-list-element"
              :class="
                !browser.browser_allowed
                  ? 'compatibility-failed-background'
                  : ''
              "
            >
              <span>
                <img
                  v-if="browser.browser_allowed"
                  src="../assets/pass_green.svg"
                  class="pass-green"
                  alt=""
                />
                <img
                  v-else
                  src="../assets/Cross_Symbol.svg"
                  class="pass-green"
                  alt=""
                />
                <span class="message">
                  <b>Browser</b> : {{ browser.browser_name }}
                </span>
              </span>
            </li>
          </ul>

        <p
          v-if="browser.browser_name==='firefox'"
          class="browser-message">
          <i>For best experience, it is recommended to use "Google Chrome" to give the test</i>
          </p>

        </div>
      </header>

      <h2 v-if="!showCookieBlockedSteps" style="margin-left: 15%;">Your browser is preventing third-party cookies. Please navigate to your browser settings, enable third-party cookies, and then reopen the link.</h2>
      <h2 v-if="!showCookieBlockedSteps" style="margin-left: 15%; margin-top: 10px;">If the issue still persists, please email to headstart@infocusp.com</h2>

      <StepsOs v-if="openOsSteps" />

      <StepsBrowser v-if="openBrowserSteps" />

      <StepsZoom v-if="openZoomSteps"
        :os="os" />
      <StepsPhysicalResolution v-else-if="openPhysicalResolutionSteps"
        :os="os" />
      <StepsScreenResolution v-else-if="openScreenResolutionSteps"
        :os="os" />

    </div>
  </div>
</template>
<script>
import FaqHeader from '../views/Faq/FaqHeader.vue'
import StepsBrowser from './Steps/StepsBrowser.vue'
import StepsOs from './Steps/StepsOs.vue'
import StepsPhysicalResolution from './Steps/StepsPhysicalResolution.vue'
import StepsScreenResolution from './Steps/StepsScreenResolution.vue'
import StepsZoom from './Steps/StepsZoom.vue'
export default {
  // NEW/Final
  name: 'Modal',
  components: { FaqHeader, StepsPhysicalResolution, StepsBrowser, StepsOs, StepsScreenResolution, StepsZoom },
  props: [
    'os',
    'browser',
    'screenSize',
    'showZoomSteps',
    'showScreenResolutionSteps',
    'showPhysicalResolutionSteps',
    'physical_width_allowed',
    'physical_height_allowed',
  ],
  data: function() {
    return {
      openZoomSteps: false,
      openScreenResolutionSteps: false,
      openPhysicalResolutionSteps: false,
      openBrowserSteps: false,
      openOsSteps: false,
    }
  },
  created() {
    if (!this.screenSize.resolution_allowed) {
      this.openScreenResolutionSteps = true
    }
    if (this.showPhysicalResolutionSteps) {
      this.openPhysicalResolutionSteps = true
    }
    if (this.showZoomSteps) {
      this.openZoomSteps = true
    }
    if (!this.browser.browser_allowed) {
      this.openBrowserSteps = true
    }
    if (!this.os.os_allowed) {
      this.openOsSteps = true
    }
  },
}
</script>

<style scoped>
.close-icon {
  float: right;
  margin-top: 0px;
  margin-right: 5px;
  width: 3vw;
}
.close-icon:hover {
  cursor: pointer;
}
.heading {
  margin: 16px auto 16px 33px;
  font-size: 24px;
  letter-spacing: 0;
  color: rgb(95, 161, 95);
}
.horizontal-line {
  border: 0.5px solid #d9d9d9;
}
.image {
  margin: 24px 76px;
}
.cross-symbol {
  margin-right: 16px;
  text-align: left;
}
.modal-mask {
  color: black;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: black;
  display: table;
  transition: opacity 0.3s ease;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-container {
  background: #ffffff;
  border: 1px solid #d9d9d9;
  box-shadow: 0 3px 0 0 rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1);
  transform: scale(1);
}
.system-compatible-header {
  text-align: left;
  display: flex;
  margin: 2vw;
}
.img-responsive {
  width: 10vw;
}
.system-compatible-header-description {
  margin-left: 3vw;
}
.system-compatible-header-description-list {
  white-space: nowrap;
  display: flex;
  flex-wrap: wrap;
}
.system-compatible-header-description-list-element {
  flex: auto;
  list-style: none;
  padding: 1vw;
  background-color: #f6f3f3;
  border: transparent;
  margin-right: 8px;
  margin-bottom: 4px;
  text-align: center;
  border-radius: 0.5vw;
  position: relative;
  font-size: 1vw;
}
.system-compatible-header-description-context {
  font-size: 1.5vw;
  margin-bottom: 2%;
}
.pass-green {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 1.5vw;
}
.browser-message {
  font-size: 11px;
}
.message {
  padding-left: 2vw;
}
.system-compatible-steps {
  background-color: #f1ebeb;
  height: 100%;
  width: 100%;
  border-radius: 3vw;
}
.system-compatible-steps-description,
.system-compatible-steps-image {
  box-sizing: border-box;
  padding: 20px;
}
.compatibility-failed-background {
  background-color: rgb(224, 175, 175);
}
.system-compatible-steps-description {
  width: 25%;
  text-align: left;
  float: left;
}
.system-compatible-steps-image {
  width: 75%;
  float: right;
}
ul {
  padding-left: 0px;
}
.container-responsive {
  height: 50%;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.system-compatible-steps-scalable-description {
  padding: 10px;
  font-size: 1vw;
}

.system-compatible-steps-image-steps {
  width: 100%;
  border-radius: 5px;
}
.system-compatible-steps-description-heading {
  font-size: 1.1vw;
}
/* responsive queries */
@media only screen and (max-width: 1050px) {
  .system-compatible-header-description-list-element {
    font-size: 1.3vw;
  }
}
@media only screen and (max-width: 1000px) {
  .img-responsive {
    height: 14vh;
  }
}
@media only screen and (max-width: 950px) {
  .system-compatible-header-description-context {
    font-size: 1.5vw;
  }
}
@media only screen and (max-width: 900px) {
  .modal-container {
    width: 100%;
  }
}
@media only screen and (max-width: 850px) {
  .system-compatible-header-description-list-element {
    font-size: 1.5vw;
  }
  .system-compatible-header-description-context {
    font-size: 1.7vw;
  }
}
@media only screen and (max-width: 800px) {
  .system-compatible-header-description-list-element {
    font-size: 1.6vw;
  }
  .system-compatible-header-description-context {
    font-size: 1.8vw;
  }
}
@media only screen and (max-width: 630px) {
  .img-responsive {
    height: 15vh;
  }
  .system-compatible-steps-scalable-description {
    padding: 2px;
  }
}
@media only screen and (max-width: 600px) {
  .system-compatible-header-description-list-element {
    font-size: 1.8vw;
  }
  .system-compatible-header-description-context {
    font-size: 2.5vw;
  }
}
@media only screen and (max-width: 550px) {
  .system-compatible-header-description-list-element {
    font-size: 2vw;
  }
}
@media only screen and (max-width: 550px) {
  .system-compatible-header-description-list-element {
    font-size: 2.2vw;
  }
}
</style>
